<template>
  <div class="auth">
    <!-- Kad dua lajur yang dikongsi oleh SETIAP skrin awam (Log Masuk, Lupa
         Kata Laluan). Lajur kiri ialah panel jenama — kecerunan teal dan motif
         carta yang SAMA seperti hero `paparanutama`, jadi skrin awam sudah
         kelihatan sebahagian daripada sistem sebelum pengguna masuk. Lajur
         kanan sengaja putih dan sunyi: borang ialah satu-satunya kerja di sini.

         Komponen ini WUJUD supaya panel itu ditulis SEKALI. Menyalinnya ke
         setiap halaman bermakna satu daripadanya pasti terlupa apabila jenama
         atau palet berubah kelak. -->
    <div class="auth__kad">

      <div class="auth__jenama">
        <!-- Motif statistik: grid, bar, garis aliran. SVG sebaris — tiada aset
             luar, dan warnanya mengikut tema. Topeng melindapkannya ke arah
             ATAS supaya bahagian teks kekal jelas dan carta duduk di kaki. -->
        <svg class="auth__bg" viewBox="0 0 460 560" preserveAspectRatio="xMidYMax slice" aria-hidden="true" focusable="false">
          <defs>
            <linearGradient id="authbar" x1="0" y1="1" x2="0" y2="0">
              <stop offset="0%" stop-color="#7fe9dd" stop-opacity=".04" />
              <stop offset="100%" stop-color="#7fe9dd" stop-opacity=".30" />
            </linearGradient>
            <linearGradient id="autharea" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="#5fe3d3" stop-opacity=".22" />
              <stop offset="100%" stop-color="#5fe3d3" stop-opacity="0" />
            </linearGradient>
          </defs>

          <g stroke="#a8f0e6" stroke-opacity=".10">
            <path d="M0 220H460M0 300H460M0 380H460M0 460H460" />
            <path d="M60 160V560M140 160V560M220 160V560M300 160V560M380 160V560" />
          </g>

          <g fill="url(#authbar)">
            <rect x="34" y="400" width="34" height="160" />
            <rect x="114" y="350" width="34" height="210" />
            <rect x="194" y="424" width="34" height="136" />
            <rect x="274" y="312" width="34" height="248" />
            <rect x="354" y="368" width="34" height="192" />
          </g>

          <path d="M20 300 L100 246 L180 282 L260 200 L340 232 L420 168 L460 186 L460 560 L20 560 Z" fill="url(#autharea)" />
          <polyline
            points="20,300 100,246 180,282 260,200 340,232 420,168 460,186"
            fill="none" stroke="#7fe9dd" stroke-opacity=".8" stroke-width="2.5"
            stroke-linecap="round" stroke-linejoin="round"
          />
          <g fill="#ffffff" fill-opacity=".85">
            <circle cx="100" cy="246" r="3.5" />
            <circle cx="260" cy="200" r="3.5" />
            <circle cx="420" cy="168" r="3.5" />
          </g>
        </svg>

        <div class="auth__isi">
          <!-- Jubin PUTIH mengelilingi logo, sama seperti menu sisi: 'HIES
               watermark.png' ialah RGB tanpa saluran alfa, jadi latar putihnya
               TERBAKAR ke dalam piksel. Di atas panel teal gelap ia akan tetap
               muncul sebagai segi empat putih — jubin ini menjadikannya satu
               keputusan reka bentuk, bukan kecacatan. -->
          <span class="auth__jubin">
            <img class="auth__logo" :src="require('@/assets/HIES watermark.png')" alt="HIES/BA">
          </span>

          <div class="auth__wordmark">
            <span class="auth__mark">HIES<span class="auth__slash">/</span>BA</span>
            <span class="auth__rule"></span>
            <span class="auth__sub">Analisis</span>
          </div>

          <h1 class="auth__tajuk">
            <span class="auth__tebal">Sistem Survei Pendapatan, Perbelanjaan Isi Rumah dan
            Kemudahan Asas</span>
          </h1>

          <!-- Dahulu di bar atas, yang kini dibuang. Ia duduk di bawah tajuk
               kerana manual menerangkan sistem yang baru sahaja dinamakan —
               dan ia KEKAL kelihatan pada telefon (lihat peraturan responsif),
               kerana pengguna yang tersekat di skrin log masuk ialah orang yang
               paling memerlukannya. -->
          <!-- <button type="button" class="auth__manual" @click="muatTurunManual">
            <v-icon size="16">mdi-file-document-outline</v-icon>
            <span>{{$t('manual pengguna')}}</span>
          </button> -->
        </div>
      </div>

      <div class="auth__borang">
        <div class="auth__borang-isi">
          <slot></slot>

          <!-- Penukar bahasa dibuang atas permintaan: skrin log masuk kini
               tunggal. Bahasa masih boleh ditukar selepas log masuk (Switchlang
               dalam MenuHeader) dan melalui URL, yang membawa locale sendiri
               (/bm/... atau /en/...). -->
          <!-- Kaki dikomen sepenuhnya, bukan dibiarkan kosong: `.auth__kaki`
               melukis garis pemisah di atasnya, yang akan tinggal sebagai garis
               tergantung tanpa kandungan. Kekal di sini untuk versi binaan.
          <div class="auth__kaki">
            <span class="auth__versi">Versi binaan: {{ buildVersion }}</span>
          </div>
          -->
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthShell',
  computed: {
    buildVersion() {
      return process.env.VUE_APP_BUILD_VERSION || 'unknown'
    }
  },
  methods: {
    muatTurunManual() {
      window.location.href = '/usermanual.pdf'
    }
  }
}
</script>

<!-- SENGAJA TIDAK `scoped`. Kandungan lajur borang datang melalui <slot>, jadi
     ia milik SKOP INDUK — atribut data-v komponen ini tidak melekat padanya,
     dan gaya berskop tidak akan mencapainya. Kelas `.auth-*` juga digunakan di
     dalam v-dialog, yang dipindahkan Vuetify ke akar aplikasi, jauh di luar
     pokok komponen ini.

     Setiap kelas diawali `auth` supaya nama umum (`kad`, `butang`, `tajuk`)
     tidak bocor ke belasan halaman lain yang berkongsi helaian global ini. -->
<style>
.auth {
  --auth-teal-900: #01463e;
  --auth-teal-800: #026254;
  --auth-teal-700: #037769;
  --auth-teal-600: #048374;
  --auth-teal-400: #0EA5A4;
  --auth-mint: #7fe9dd;
  --auth-hair: #dbeeeb;

  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  /* Latar SENGAJA tiada di sini — ia milik lapisan `fixed` dalam
     publictemplate.vue supaya ia menutupi viewport tanpa penghujung. */
}

/* Radius 4px sepadan `.hero` — objek terapung, jadi bayang lebih dalam
   daripada kad dalam halaman. */
.auth__kad {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  width: 100%;
  max-width: 960px;
  border-radius: 4px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 24px 64px rgba(1, 70, 62, .22), 0 2px 8px rgba(1, 70, 62, .10);
}

/* ============================ PANEL JENAMA ============================ */
.auth__jenama {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  padding: 44px 40px;
  background: linear-gradient(120deg, #01463e 0%, #026254 46%, #048374 100%);
}
/* Carta dilindap ke ATAS: teks duduk di atas, motif di kaki panel. */
.auth__bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  -webkit-mask-image: linear-gradient(180deg, transparent 18%, #000 78%);
  mask-image: linear-gradient(180deg, transparent 18%, #000 78%);
}
.auth__isi {
  position: relative;
  z-index: 1;
}

.auth__jubin {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  padding: 4px 5px;
  border-radius: 10px;
  background: #ffffff;
}
/* `object-fit: contain` WAJIB: sumbernya 1976x1586 (landskap 1.25:1). Tanpanya
   imej diregang mengikut kotak dan logo menjadi herot. */
.auth__logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.auth__wordmark {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 22px 0 18px;
  padding-bottom: 14px;
  border-bottom: 2px solid rgba(127, 233, 221, .35);
}
.auth__mark {
  font-size: var(--fs-lg);
  font-weight: 800;
  letter-spacing: 2.5px;
  color: #ffffff;
}
.auth__slash {
  color: var(--auth-mint);
  margin: 0 1px;
}
.auth__rule {
  width: 1px;
  height: 20px;
  background: rgba(255, 255, 255, .18);
}
.auth__sub {
  font-size: var(--fs-lg);
  font-weight: 500;
  letter-spacing: 1.4px;
  color: var(--auth-mint);
}

.auth__tajuk {
  font-size: var(--fs-xl);
  font-weight: 300;
  line-height: 1.35;
  color: rgba(255, 255, 255, .82);
  margin: 0;
}
.auth__tebal {
  font-weight: 700;
  color: #ffffff;
}

.auth__manual {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 22px;
  padding: 8px 14px;
  border: 1px solid rgba(127, 233, 221, .45);
  border-radius: 4px;
  background: rgba(127, 233, 221, .10);
  cursor: pointer;
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--auth-mint);
  transition: background-color .18s ease;
}
.auth__manual .v-icon {
  color: var(--auth-mint) !important;
}
.auth__manual:hover {
  background: rgba(127, 233, 221, .20);
}
.auth__manual:focus-visible {
  outline: 2px solid var(--auth-mint);
  outline-offset: 2px;
}

/* ============================== LAJUR BORANG ============================== */
.auth__borang {
  display: flex;
  align-items: center;
  padding: 44px 40px;
}
.auth__borang-isi {
  width: 100%;
}

.auth__kaki {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--auth-hair);
}
.auth__versi {
  font-size: var(--fs-2xs);
  letter-spacing: .4px;
  color: #8aa5a1;
}

/* ==================== ELEMEN BORANG (kandungan slot) ==================== */
.auth-kening {
  font-size: var(--fs-2xs);
  font-weight: 600;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: var(--auth-teal-600);
  margin-bottom: 6px;
}
.auth-tajuk {
  font-size: var(--fs-xl);
  font-weight: 700;
  line-height: 1.25;
  color: var(--auth-teal-900);
  margin: 0;
}
.auth-nota {
  font-size: var(--fs-sm);
  line-height: 1.5;
  color: #5d7a76;
  margin: 6px 0 26px;
}

/* Warna aksen medan. Vuetify mewarnakan birai/label melalui prop `color`,
   tetapi ikon prepend kekal kelabu lalai — ia diselaraskan di sini. */
.auth .v-input__prepend-inner .v-icon {
  color: var(--auth-teal-600);
}
.auth .v-text-field--outlined fieldset {
  border-color: var(--auth-hair);
}
.auth .v-text-field--outlined:hover fieldset {
  border-color: #9fd3cb;
}

/* Pautan sokongan di bawah medan (cth. "Lupa Kata Laluan").
   `position: relative` + `z-index` BUKAN kosmetik: margin negatif menariknya ke
   dalam ruang `.v-text-field__details`, dan `.v-input__slot` Vuetify ialah
   elemen BERPOSISI — ia dicat DI ATAS jiran tak-berposisi tidak kira susunan
   DOM. Tanpa dua sifat ini pautan kelihatan tetapi klik mendarat pada lapisan
   medan di atasnya, jadi ia langsung tidak boleh ditekan. */
.auth-pautan {
  position: relative;
  z-index: 1;
  margin: -18px 0 18px;
  text-align: right;
}
.auth-pautan a {
  font-size: var(--fs-2xs);
  font-weight: 600;
  color: var(--auth-teal-600);
  text-decoration: none;
}
.auth-pautan a:hover,
.auth-pautan a:focus-visible {
  text-decoration: underline;
}

/* Butang natif dan BUKAN v-btn: kecerunan penuh lebar dengan anak panah yang
   bergerak memerlukan lapisan `.v-btn__content` Vuetify dilawan pada setiap
   sifat. Elemen <button> memberi jenis `submit`, fokus papan kekunci dan
   semantik yang sama tanpa pertarungan itu. */
.auth-butang {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 48px;
  margin-top: 8px;
  border-radius: 4px;
  border: 0;
  cursor: pointer;
  font-size: var(--fs-md);
  font-weight: 700;
  letter-spacing: .6px;
  color: #ffffff;
  background: linear-gradient(120deg, #01463e 0%, #026254 46%, #048374 100%);
  box-shadow: 0 6px 18px rgba(1, 70, 62, .28);
  transition: box-shadow .2s ease, transform .2s ease;
}
.auth-butang:hover {
  box-shadow: 0 10px 24px rgba(1, 70, 62, .36);
  transform: translateY(-1px);
}
.auth-butang:active {
  transform: translateY(0);
}
/* Hex literal, BUKAN var(--auth-*): butang ini digunakan semula di dalam dialog
   Pilih Peranan, dan Vuetify memindahkan kandungan v-dialog ke akar aplikasi —
   di luar `.auth`, tempat pembolehubah ini diisytiharkan. */
.auth-butang:focus-visible {
  outline: 2px solid #0EA5A4;
  outline-offset: 3px;
}
.auth-butang__anak {
  color: #7fe9dd !important;
  transition: transform .2s ease;
}
.auth-butang:hover .auth-butang__anak {
  transform: translateX(4px);
}
/* Varian padat — lebar kandungan, bukan lebar penuh borang. */
.auth-butang--padat {
  width: auto;
  height: 40px;
  margin-top: 0;
  padding: 0 20px;
  font-size: var(--fs-sm);
}

/* Tindakan kedua yang senyap (Kembali, Tutup). */
.auth-batal {
  height: 40px;
  padding: 0 16px;
  border: 0;
  border-radius: 4px;
  background: none;
  cursor: pointer;
  font-size: var(--fs-sm);
  font-weight: 600;
  color: #5d7a76;
}
.auth-batal:hover {
  background: #eef8f6;
  color: #026254;
}
.auth-batal:focus-visible {
  outline: 2px solid #0EA5A4;
  outline-offset: 2px;
}
.auth-aksi {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ============================== RESPONSIF ==============================
   Di bawah 900px kad menjadi satu lajur dan panel jenama menguncup menjadi
   jalur kepala: logo, wordmark dan pautan manual sahaja. Tajuk panjang dibuang
   di situ — pada telefon ia menolak borang ke bawah lipatan, dan borang itulah
   satu-satunya sebab halaman ini wujud. */
@media (max-width: 899px) {
  .auth__kad {
    grid-template-columns: minmax(0, 1fr);
    max-width: 460px;
  }
  .auth__jenama {
    padding: 22px 24px;
  }
  .auth__jubin {
    width: 48px;
    height: 48px;
  }
  .auth__wordmark {
    margin: 14px 0 0;
    padding-bottom: 0;
    border-bottom: 0;
  }
  .auth__tajuk,
  .auth__bg {
    display: none;
  }
  .auth__manual {
    margin-top: 14px;
  }
  .auth__borang {
    padding: 28px 24px 24px;
  }
}

/* Satu detik muat — kad naik sekali, bukan kesan bertaburan. */
@media (prefers-reduced-motion: no-preference) {
  .auth__kad {
    animation: authNaik .45s cubic-bezier(.2, .7, .3, 1) both;
  }
  @keyframes authNaik {
    from { opacity: 0; transform: translateY(14px); }
    to   { opacity: 1; transform: none; }
  }
}
</style>
